var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeliveryTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.988 3.988s4.316 2.958 4.69 3.334a.96.96 0 1 1-1.357 1.357c-.375-.375-3.333-4.69-3.333-4.69M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0"
})));
export { SvgDeliveryTime as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvZGVsaXZlcnktdGltZS4wNDU3YmI3ZC5zdmciOw==";